// extracted by mini-css-extract-plugin
module.exports = {"root":"popover_root__1LkRj"};